<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80 w-75" @mousedown.stop="" @click="dontClose">
          <div class="modal-header">
            <!-- <h5 class="mb-0">
              {{ isEdit
                ? $t('mandate.sdd_blacklist.edit_blacklist')
                : $t('mandate.sdd_blacklist.generation_title')
              }}
            </h5> -->
            <div class="panel-heading ml-4 pl-2">
              <b-col cols="12" class="formTitleBlock">
                <h4 class="content-block labelAccordionForm">
                  <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                  {{ isEdit
                    ? $t('mandate.sdd_blacklist.edit_blacklist')
                    : $t('mandate.sdd_blacklist.generation_title') }}
                </h4>
              </b-col>
            </div>
          </div>

          <div class="modal-body m-0 p-5">
            <div class="col-12 px-0 px-md-2">
              <b-row>
                <b-col cols="12">
                  <span class="filter-item-title d-block mb-2">
                    {{ $t('mandate.sdd_blacklist.blacklist_type') }}
                  </span>

                  <div class="d-flex align-items-center mb-4">
                    <div class="custom-control custom-radio mr-5">
                      <input
                        id="blacklistGroup"
                        v-model="localType"
                        type="radio"
                        class="custom-control-input"
                        value="group"
                        @change="onTypeChange"
                      />
                      <label class="custom-control-label" for="blacklistGroup">
                        {{ $t('mandate.sdd_blacklist.account_group') }}
                      </label>
                    </div>

                    <div class="custom-control custom-radio">
                      <input
                        id="blacklistIndividual"
                        v-model="localType"
                        type="radio"
                        class="custom-control-input"
                        value="individual"
                        @change="onTypeChange"
                      />
                      <label class="custom-control-label" for="blacklistIndividual">
                        {{ $t('mandate.sdd_blacklist.individual_account') }}
                      </label>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6" cols="12" class="mb-4">
                  <span class="filter-item-title d-block mb-1">
                    {{ $t('mandate.sdd_blacklist.country_code') }}
                  </span>
                  <input
                    v-model.trim="localForm.country_code"
                    class="filter-item-content w-100"
                    :disabled="localType !== 'group'"
                    maxlength="2"
                    :placeholder="$t('mandate.sdd_blacklist.placeholder_country_code')"
                  />
                </b-col>

                <b-col md="6" cols="12" class="mb-4">
                  <span class="filter-item-title d-block mb-1">
                    {{ $t('mandate.sdd_blacklist.bank_code') }}
                  </span>
                  <input
                    v-model.trim="localForm.bank_code"
                    class="filter-item-content w-100"
                    :disabled="localType !== 'group'"
                    maxlength="20"
                    :placeholder="$t('mandate.sdd_blacklist.placeholder_bank_code')"
                  />
                </b-col>

                <b-col md="6" cols="12" class="mb-4">
                  <span class="filter-item-title d-block mb-1">
                    {{ $t('mandate.sdd_blacklist.bic') }}
                  </span>
                  <input
                    v-model.trim="localForm.bic"
                    class="filter-item-content w-100"
                    :disabled="localType !== 'group'"
                    maxlength="11"
                    :placeholder="$t('mandate.sdd_blacklist.placeholder_bic')"
                  />
                </b-col>

                <b-col md="6" cols="12" class="mb-4">
                  <span class="filter-item-title d-block mb-1">
                    {{ $t('mandate.sdd_blacklist.full_iban') }}
                  </span>
                  <input
                    v-model.trim="localForm.full_iban"
                    class="filter-item-content w-100"
                    :disabled="localType !== 'individual'"
                    maxlength="34"
                    :placeholder="$t('mandate.sdd_blacklist.placeholder_full_iban')"
                  />
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="modal-footer m-0 d-block">
            <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
              <b-col cols="3">
                <b-button round class="button-action mx-2 mb-2" @click="$emit('close')">
                  {{ $t('common.bck') }}
                </b-button>
              </b-col>

              <b-col cols="3">
                <b-button
                  class="mx-2"
                  variant="primary"
                  :disabled="!canSave"
                  @click="save"
                >
                  <span>{{ $t('mandate.sdd_blacklist.save') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BlacklistPopUp',

  props: {
    form: {
      type: Object,
      default: () => ({
        country_code: '',
        bank_code: '',
        bic: '',
        full_iban: ''
      })
    },
    type: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      localType: this.type || '',
      localForm: {
        country_code: this.form.country_code || '',
        bank_code: this.form.bank_code || '',
        bic: this.form.bic || '',
        full_iban: this.form.full_iban || ''
      }
    }
  },

  computed: {
    canSave () {
      if (this.localType === 'group') {
        return !!(
          this.localForm.country_code ||
          this.localForm.bank_code ||
          this.localForm.bic
        )
      }

      if (this.localType === 'individual') {
        return !!this.localForm.full_iban
      }

      return false
    }
  },

  created () {
    window.addEventListener('click', this.handleClick)
  },

  destroyed () {
    window.removeEventListener('click', this.handleClick)
  },

  methods: {
    dontClose (e) {
      if (!e.target.closest('.modal-action')) {
        e.stopPropagation()
      }
    },

    handleClick (e) {
      if (e.target.closest('.modal-mask')) {
        this.$emit('close')
      }
    },

    onTypeChange () {
      if (this.localType === 'group') {
        this.localForm.full_iban = ''
      } else if (this.localType === 'individual') {
        this.localForm.country_code = ''
        this.localForm.bank_code = ''
        this.localForm.bic = ''
      }
    },

    save () {
      if (!this.canSave) return

      this.$emit('savepopup', {
        type: this.localType,
        form: {
          country_code: this.localForm.country_code || null,
          bank_code: this.localForm.bank_code || null,
          bic: this.localForm.bic || null,
          full_iban: this.localForm.full_iban || null
        }
      })
    }
  }
}
</script>
